import { Card as AntCard } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { ProductiveHeading06 } from 'components/styles';

interface WidgetProps extends ClassNamePropsWithChildren {
  title?: string | React.ReactNode;
  loading?: boolean;
}

const Title = styled.div`
  ${ProductiveHeading06};
`;

const Card = styled(AntCard)`
  padding: var(--spacing-05);
  padding-bottom: 0;
  box-shadow: var(--shadow-02);
  height: 240px;
  overflow-y: auto;
  .ant-card-body {
    padding: 0;
  }
`;

export const Widget: FC<WidgetProps> = ({
  loading,
  title,
  className,
  children,
}) => (
  <Card loading={loading} bordered={false} className={className}>
    {title && <Title>{title}</Title>}
    {!loading && children}
  </Card>
);
